import React from 'react';
import styles from './no-apps.module.scss';
import { Graphic } from '@workday/canvas-kit-react/icon';
import { emptyStateSpreadsheetGraphic } from '@workday/canvas-graphics-web';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface NoAppsProps {
    className?: string;
}

export function NoApps({ className }: NoAppsProps) {
    const { t } = useTranslation('account');

    return (
        <div className={classNames(styles.emptyState, className)}>
            <Graphic src={emptyStateSpreadsheetGraphic} />
            <h1>{t('NoApps.noResults')}</h1>
        </div>
    );
}
